export const buildVersion = 'PLACEHOLDER';
